"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useRef, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
const ACCEPTED_FORMATS = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
const ACCEPTED_FORMATS_DISPLAY = ACCEPTED_FORMATS.map(format => `.${format.replace("image/", "")}`).join(", ");
const FILE_SIZE_LIMIT = 10485760;
export default function CreateWaveImageInput(t0) {
  const $ = _c(27);
  const {
    imageToShow,
    setFile
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const inputRef = useRef(null);
  let t1;
  if ($[0] !== setFile || $[1] !== setToast) {
    t1 = file => {
      if (ACCEPTED_FORMATS.indexOf(file.type) === -1) {
        setToast({
          type: "error",
          message: "Invalid file type"
        });
      } else {
        if (file.size > FILE_SIZE_LIMIT) {
          setToast({
            type: "error",
            message: "File size must be less than 10MB"
          });
        } else {
          setFile(file);
        }
      }
    };
    $[0] = setFile;
    $[1] = setToast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onFileChange = t1;
  let t2;
  if ($[3] !== onFileChange) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      if (e?.dataTransfer?.files?.length) {
        onFileChange(e.dataTransfer.files[0]);
      }
    };
    $[3] = onFileChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDrop = t2;
  const [dragging, setDragging] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      if (e_0.type === "dragenter" || e_0.type === "dragover") {
        setDragging(true);
      } else {
        if (e_0.type === "dragleave") {
          setDragging(false);
        } else {
          if (e_0.type === "drop") {
            setDragging(false);
          }
        }
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDrag = t3;
  let t4;
  if ($[6] !== imageToShow) {
    t4 = <div className="tw-flex-shrink-0">{imageToShow ? <img src={URL.createObjectURL(imageToShow)} alt="Profile image" className="w-flex-shrink-0 tw-h-14 tw-w-14 tw-object-cover tw-rounded-full sm:tw-h-20 sm:tw-w-20 tw-bg-iron-700 tw-ring-2 tw-ring-iron-800" /> : <div className="w-flex-shrink-0 tw-h-14 tw-w-14 tw-object-cover tw-rounded-full sm:tw-h-20 sm:tw-w-20 tw-bg-iron-700 tw-ring-2 tw-ring-iron-900" />}</div>;
    $[6] = imageToShow;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== imageToShow || $[9] !== setFile) {
    t5 = imageToShow && <button onClick={() => setFile(null)} type="button" aria-label="Remove file" className="tw-inline-flex tw-items-center tw-justify-center tw-border-0 tw-rounded-full tw-bg-transparent tw-text-red tw-text-sm tw-font-semibold hover:tw-bg-red/10 tw-transition tw-duration-200 tw-ease-out">Delete</button>;
    $[8] = imageToShow;
    $[9] = setFile;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-2">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `
        ${dragging ? "tw-border-iron-600 tw-bg-iron-800" : "tw-bg-iron-900 tw-border-iron-700"}
      tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-40 tw-border-2 tw-border-dashed tw-rounded-lg tw-cursor-pointer  hover:tw-border-iron-600 hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out
      `;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-900 group-hover:tw-bg-iron-800 tw-border tw-border-solid tw-border-iron-700 tw-transition tw-duration-300 tw-ease-out"><div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-50"><svg className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-text-iron-50" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-5 tw-pb-6">{t8}<p className="tw-mt-4 tw-mb-2 tw-text-xs sm:tw-text-sm tw-font-normal tw-text-iron-400"><span className="tw-font-medium tw-text-white">Click to upload</span>{" "}or drag and drop</p><p className="tw-mb-0 tw-text-xs tw-font-normal tw-text-iron-400">JPEG, JPG, PNG, GIF, WEBP</p></div>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onFileChange) {
    t10 = <input id="pfp-upload-input" ref={inputRef} type="file" className="tw-hidden" accept={ACCEPTED_FORMATS_DISPLAY} onChange={e_1 => {
      if (e_1.target.files) {
        const f = e_1.target.files[0];
        onFileChange(f);
      }
    }} />;
    $[16] = onFileChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <label className={t7}>{t9}{t10}</label>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleDrop || $[22] !== t11) {
    t12 = <div onDrop={handleDrop} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} className="tw-relative tw-group tw-flex tw-items-center tw-justify-center tw-w-full">{t11}</div>;
    $[21] = handleDrop;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t6) {
    t13 = <div className="tw-flex tw-gap-x-5">{t6}{t12}</div>;
    $[24] = t12;
    $[25] = t6;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}